module.exports = __webpack_public_path__ + "media/images/admin2/AdminBookingEditSpotMemo__pencil-38c5a31d68e13b8480c197674b2b0158.svg";